import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { scrollToRef } from "../../util";
import {
  K_COLORS_LIGHT_GREY,
  K_COLORS_SMOKE_GREY,
  K_LETTER_SPACING,
} from "constants.js";
import { useMousePosition } from "hooks";

const NavItem = (props) => {
  const { label, anchorRef } = props;
  const [isActive, setIsActive] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const mousePosition = useMousePosition();

  const itemColor = isActive
    ? { color: K_COLORS_LIGHT_GREY }
    : { color: K_COLORS_SMOKE_GREY };

  useEffect(() => {
    if (anchorRef.current) {
      const refTop = anchorRef.current.offsetTop;
      const refBottom = refTop + anchorRef.current.offsetHeight;
      if (isHovered) {
        setIsActive(true);
      } else {
        setIsActive(mousePosition > refTop && mousePosition <= refBottom);
      }
    }
  }, [anchorRef, isActive, isHovered, mousePosition]);

  return (
    <div
      onClick={() => scrollToRef(anchorRef)}
      key={label}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ ...styles.navItem, ...itemColor }}
    >
      {label}
    </div>
  );
};

const styles = {
  navItem: {
    transition: "0.5s",
    paddingLeft: "1.5rem",
    fontSize: "1rem",
    letterSpacing: K_LETTER_SPACING,
    cursor: "pointer",
    marginTop: "0.2rem",
    marginBottom: "0.1rem",
    textAlign: "right",
  },
};

NavItem.propTypes = {
  label: PropTypes.string.isRequired,
  anchorRef: PropTypes.shape().isRequired,
};

export default NavItem;
